<template>
  <div :key="path" :class="['sr-documentation', ...classes]" v-html="parsed"></div>
</template>

<script>
import parser from "../../../../mixins/parser"

export default {
  name: "DocumentationDiv",
  mixins: [parser],
  props: {
    path: { required: true, type: String },
    classes: { required: false, type: String },
    icon: { required: false, type: String, default: "fa-question-circle" },
    title: { required: false, type: Boolean, default: true },
  },
  data: () => ({
    dialog: false,
    documentation: {},
    raw: "",
    parsed: "",
  }),
  computed: {
    isSecuratingAccount() {
      return this.$store.state.auth.user["doc"] === true
    },
    documentationLocale() {
      return this.$i18n.locale.toLowerCase()
    }
  },
  mounted() {
    this.loadDocumentation()
  },
  methods: {
    loadDocumentation() {
      this.$axios
          .get("office/common/documentations/by?path=" + encodeURIComponent(this.path))
          .then(response => {
            this.documentation = response.data.data

            //const locale = this.$i18n.locale.toLowerCase()
            const locale = this.documentationLocale

            this.parse(this.documentation[`content_${locale}`])
            if (this.isSecuratingAccount) {
              this.parsed = this.parsed + `<br><b>Documentation : </b><b class='green--text'>${this.path}</b>`
            } else {
              this.parsed = this.parsed.replace(/<pre>.*<\/pre>/s, "")
              this.parsed = this.parsed.replace(/<a /g, '<a target="_blank" class="blue--text"')
            }
            if(!this.title) {
              this.parsed = this.parsed.replace(/<h2.*<\/h2>/s, "")
            }
            //-- Force H1, H2, H3 with primary--text class
            this.parsed = this.parsed.replace('<h1 class="headline', '<h1 class="headline primary--text')
            this.parsed = this.parsed.replace('<h2 class="headline', '<h2 class="headline primary--text')
            this.parsed = this.parsed.replace('<h3 class="headline', '<h3 class="headline primary--text')
            this.parsed = this.parsed.replace('<h4 class="headline', '<h4 class="headline primary--text')
            this.parsed = this.parsed.replace('<h5 class="headline', '<h5 class="headline primary--text')
            this.parsed = this.parsed.replace('<h6 class="headline', '<h6 class="headline primary--text')

            //-- We add a question mark at the begining of the documentationDiv ?
            if (this.icon !== "false") {
              this.parsed =
                  '<i aria-hidden="true" class="v-icon notranslate fa ' +
                  this.icon +
                  ' theme--light primary--text" style=""></i>' +
                  this.parsed
            }
          })
          .catch(() => {
            if (this.isSecuratingAccount) {
              this.parsed = this.$t("documentation.empty", { path: this.path })
            }
          })
    },
  }
}
</script>
